import React from 'react'
import { WithTemplate } from '@morningtrain/react-app'
import Cart from 'services/cart/Cart'
import CartContentCollection from 'services/cart/CartContentCollection'
import Section from 'layouts/page/Section'
import ContentWrap from 'layouts/page/ContentWrap'
import Title from 'layouts/page/Title'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import RemoveFromCart from 'support/actions/RemoveFromCart'
import { EditQuantity } from 'support/displays'
import TableWithHeaderWrap from 'ui/tables/TableWithHeaderWrap'
import TableScrollContainer from 'ui/tables/TableScrollContainer'
import WhenEmptyCartContent from 'support/conditionals/WhenEmptyCartContent'
import CartWrapper from 'services/cart/CartWrapper'
import ContentWrapper from 'ui/layouts/ContentWrapper'
import DomainInfoColumns from 'widgets/domains/DomainInfoColumns'
import DualRowColumn from 'ui/columns/DualRowColumn'
import WhenModelValuesNotEqual
  from 'support/conditionals/WhenModelValuesNotEqual'

export default function Overview (props) {
  return (
    <WithTemplate>
      <ContentWrapper>
        <CartWrapper>
          <CartContentCollection>
            <ContentWrap>
              <Section>
                <TableWithHeaderWrap>
                  <div className='px-6 pt-10 pb-8 sm:flex sm:justify-between sm:items-center sm:pt-12 sm:px-10'>
                    <div>
                      <Title className='text-2xl' />
                    </div>
                  </div>

                  <TableScrollContainer>
                    <Columns.Table selectOnClick>
                      <Columns.Column display={RemoveFromCart} />
                      <DomainInfoColumns />
                      <Columns.Column display={EditQuantity} label='Antal Links' />
                    </Columns.Table>
                  </TableScrollContainer>

                  <WhenEmptyCartContent>
                    {/* TODO - empty cart */}
                    <div className='index-table-layout-footer border-t border-gray-200 px-6 py-8 sm:px-10'>
                      <p className='text-center'>Tom kurv</p>
                    </div>
                  </WhenEmptyCartContent>

                </TableWithHeaderWrap>
              </Section>
            </ContentWrap>
          </CartContentCollection>
        </CartWrapper>
      </ContentWrapper>
    </WithTemplate>
  )
}
